import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { DesktopMinWidth } from "../../ScreenChecker";
import { selectLocale } from "../../../lang/localeSlice";
import { StyledMarkdownPage } from "./MarkdownPage.styled";

import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

// Renders a localized legal/markdown document. `docs` maps a locale code
// (e.g. "ko-KR") to the imported markdown asset URL; the document matching the
// current locale is fetched and rendered, falling back to en-US.
const MarkdownPage = ({ title, docs }) => {
  const isDesktop = useMediaQuery({ minWidth: DesktopMinWidth });
  const locale = useSelector(selectLocale);

  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    const doc = docs[locale] || docs["en-US"] || Object.values(docs)[0];
    let active = true;
    fetch(doc)
      .then((res) => res.text())
      .then((text) => active && setMarkdown(text))
      .catch((error) => console.error(error));
    return () => {
      active = false;
    };
  }, [locale, docs]);

  return (
    <StyledMarkdownPage isDesktop={isDesktop}>
      <div className="container">
        <div className="title">{title}</div>
        <div className="content">
          <ReactMarkdown remarkPlugins={[gfm]} children={markdown} />
        </div>
      </div>
    </StyledMarkdownPage>
  );
};

export default MarkdownPage;
